import { render, staticRenderFns } from "./Picker.vue?vue&type=template&id=620a6131&scoped=true&"
import script from "./Picker.vue?vue&type=script&lang=js&"
export * from "./Picker.vue?vue&type=script&lang=js&"
import style0 from "./Picker.vue?vue&type=style&index=0&id=620a6131&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620a6131",
  null
  
)

export default component.exports